<template>
  <div class="item" :class="itemClass">
    <div class="item-title">
      <span>{{ title }}</span>
      <mf-icon fill :icon="isActive ? 'check_circle' : 'do_not_disturb_on'" :color="isActive ? 'verde-l20' : 'cinza-0'"></mf-icon>
    </div>

    <template v-if="bodyType === 'basic'">
      <template v-if="isActive">
        <span class="item-subtitle">Data de envio: {{ sendDate }}</span>
        <div class="item-body">
          <pre class="basic-message"> {{ messageText }} </pre>
        </div>
      </template>

      <template v-else>
        <span class="item-subtitle">Nenhuma mensagem na campanha</span>
        <div class="item-body item-empty-body">
          <mf-icon color="cinza-l10">speaker_notes_off</mf-icon>
        </div>
      </template>
    </template>

    <template v-else-if="bodyType === 'push'">
      <template v-if="isActive">
        <span class="item-subtitle">Data de envio: {{ sendDate }}</span>
        <div class="item-body">
          <div class="push-message-title-container">
            <div class="push-icon"></div>
            <span class="push-message-title">
              {{ messageTitle }}
            </span>
          </div>
          <pre> {{ messageText }} </pre>
        </div>
      </template>

      <template v-else>
        <span class="item-subtitle">Nenhum push na campanha</span>
        <div class="item-body item-empty-body">
          <mf-icon color="cinza-l10">speaker_notes_off</mf-icon>
        </div>
      </template>
    </template>

    <template v-else-if="bodyType === 'download'">
      <template v-if="isActive">
        <span class="item-subtitle">Materiais para impressão</span>
        <div id="industry_proposal_communication_click_download" class="download-body-container" @click="downloadFile">
          <div class="download-body-content">
            <div class="download-button-icon">
              <mf-icon icon="download" color="#0079f2"></mf-icon>
            </div>
            <span>Fazer download</span>
          </div>
        </div>
      </template>

      <template v-else>
        <span class="item-subtitle">Nenhum material na campanha</span>
        <div class="item-body item-empty-body">
          <mf-icon color="cinza-l10">link_off</mf-icon>
        </div>
      </template>
    </template>
  </div>
</template>

<script>
export default {
  name: 'CommunicationItem',
  props: {
    communication: {
      type: Object,
      required: false,
      default: null,
    },
    bodyType: {
      type: String,
      default: 'basic',
      required: false,
      validator: (value) => ['basic', 'push', 'download'].includes(value),
    },
    segmentationType: {
      type: String,
      required: true,
      validator: (value) => ['massive', 'club', 'personalized'].includes(value),
    },
    title: {
      type: String,
      required: true,
    },
  },
  computed: {
    itemClass() {
      return this.isActive ? '' : 'inactive-item'
    },
    isActive() {
      return this.communication && this.communication !== null && this.communication !== undefined
    },
    sendDate() {
      return this.communication?.sendDate
    },
    messageText() {
      return this.communication?.messageText
    },
    messageTitle() {
      return this.communication?.messageTitle
    },
    url() {
      return this.communication?.url
    },
    getSegmentationLabel() {
      switch (this.segmentationType) {
        case 'massive':
          return 'Campanha Massiva'
        case 'personalized':
          return 'Campanha Segmentada'
        case 'club':
          return 'Campanha Clube'
        default:
          return ''
      }
    },
    getSegmentationLabelDescription() {
      switch (this.segmentationType) {
        case 'massive':
          return 'massivas'
        case 'personalized':
          return 'segmentadas'
        case 'club':
          return 'do clube'
        default:
          return ''
      }
    },
  },
  methods: {
    downloadFile() {
      window.open(this.url ?? '', '_blank')
    },
  },
}
</script>

<style lang="scss" scoped>
.v-tooltip__content {
  background: #fff;
  border: 1px solid $cinza-l70;
  max-width: 250px;
  padding: 12px;
}

.custom-tooltip {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;

  .description {
    color: $cinza-d10;
  }
}

pre {
  text-wrap: wrap;
}

.download-body-container {
  flex: 1;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  .download-body-content {
    cursor: pointer;
    user-select: none;
    background-color: #d2e9ff33;
    height: 64px;
    flex: 1;
    border-radius: 16px;
    padding: 12px;

    display: flex;
    align-items: center;
    gap: 8px;

    span {
      font-weight: 400;
      font-size: 14px;
      color: #004d99;
    }

    .download-button-icon {
      background-color: #d2e9ff66;
      padding: 8px;
      border-radius: 14px;
    }

    &:hover {
      background-color: #ebf5ff;
    }
  }

  .empty-download-body-content {
    background-color: transparent;

    .download-button-icon {
      background-color: #eee;
    }

    .item-empty-body-content {
      margin-right: 50%;
    }
  }
}

.push-icon {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: linear-gradient(0deg, #d9d9d9, #d9d9d9), linear-gradient(111.8deg, #cad1d8 12.68%, #e6e8ea 50.55%, #cad1d8 90.36%);
  margin-right: 8px;
}

.push-message-title-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 4px;

  .push-message-title {
    color: $cinza-d20;
    font-size: 12px;
    font-weight: bold;
  }
}

.item {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-width: 20%;
  border: 1px #0da7404d solid;
  padding: 12px 12px 16px 12px;
  border-radius: 16px;

  .item-title {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;

    color: $marca-0;
    font-size: 16px;
    font-weight: bold;
  }

  .item-subtitle {
    color: $cinza-0;
    font-size: 14px;
    font-weight: 400;
  }

  .item-body {
    flex: 1;
    margin-top: 16px;
    padding: 8px 10px;
    background-color: $cinza-l90;
    border-radius: 16px;
    min-height: 64px;
  }

  .basic-message {
    color: $cinza-d20;
    font-size: 12px;
    font-weight: 400;
  }

  .item-empty-body {
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    gap: 8px;
    padding: 16px 10px;
    background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='16' ry='16' stroke='%23969EA7' stroke-width='1' stroke-dasharray='7' stroke-dashoffset='0' stroke-linecap='butt'/%3e%3c/svg%3e");
  }

  .item-empty-body-content {
    width: 100%;
    border-radius: 4px;
    height: 8px;
    background: linear-gradient(270deg, #ecedf0 0%, #d2d6d9 100%);
  }
}

.inactive-item {
  border-color: $cinza-l70;
}
</style>
